import React from 'react'
import {toast, ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

/**
 * Drop-in replacement for react-notifications' `NotificationManager`, backed by
 * react-toastify (React 16 compatible). Keeps the original call signature
 * `(message, title, timeout)` so existing call sites work unchanged:
 *   - `title` is unused by current call sites and is intentionally ignored.
 *   - `timeout` (ms) maps to react-toastify's `autoClose` option; when omitted,
 *     react-toastify's default (5000ms) applies — matching react-notifications.
 */
const buildOptions = (timeout) =>
  typeof timeout === 'number' ? {autoClose: timeout} : undefined

export const NotificationManager = {
  info: (message, title, timeout) => toast.info(message, buildOptions(timeout)),
  success: (message, title, timeout) =>
    toast.success(message, buildOptions(timeout)),
  warning: (message, title, timeout) =>
    toast.warning(message, buildOptions(timeout)),
  error: (message, title, timeout) => toast.error(message, buildOptions(timeout))
}

/**
 * Drop-in replacement for react-notifications' `NotificationContainer`.
 * Forwards any props through to react-toastify's `ToastContainer`.
 */
export const NotificationContainer = (props) => <ToastContainer {...props} />
